import React from 'react';
import { useTranslation } from 'react-i18next';

import Spinner from '../../../common/components/misc/Spinner';
import { useRouter } from '../../common/RouterHooks';
import OAuthCallbackContainer, { OAuthCallbackContainerProps } from './containers/OAuthCallbackContainer';

const OAuthCallback: React.FC<OAuthCallbackContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    const routeProps = useRouter();
    return (
        <OAuthCallbackContainer {...containerProps} t={t} routeProps={routeProps}>
            {(props) => (
                <Spinner />
            )}
        </OAuthCallbackContainer>
    );
};

export default OAuthCallback;
